// src/features/auth/authSlice.js
import { createAsyncThunk } from '@reduxjs/toolkit';
import { deleteAccountApi, getUserApi, updateUserProfileApi } from '../http';

export const getUserThunk = createAsyncThunk('user/getUser', async (_, { rejectWithValue }) => {
  try {
    return await getUserApi();
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const updateUserProfileThunk = createAsyncThunk(
  'auth/updateUser',
  async (body, { rejectWithValue }) => {
    try {
      return await updateUserProfileApi(body);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const deleteAccountThunk = createAsyncThunk('user/deleteAccount', async (_, { rejectWithValue }) => {
  try {
    return await deleteAccountApi();
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});
